import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectCoworkingAccessFilter } from 'shared/selectors/advancedFilters';
import { ECoworkingAccess } from '../../../../../../../packages/JsonQuery/types/coworkingAccess';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const CoworkingAccessContainer: FC = () => {
  const { label, value, options } = useSelector(selectCoworkingAccessFilter);

  const onChange = useFilterChangeCallback();

  const handleCoworkingAccessChange = useCallback(
    (newValue: NonEmptyArray<ECoworkingAccess> | null) => {
      const allDay = newValue?.includes(ECoworkingAccess.AllDayAccess) ? true : null;
      const allWeek = newValue?.includes(ECoworkingAccess.AllWeekAccess) ? true : null;

      onChange(
        { action: 'setAllDayAccess', arguments: [allDay] },
        { action: 'setAllWeekAccess', arguments: [allWeek] },
      );
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleCoworkingAccessChange} />
    </AdvancedFilterRow>
  );
};
